/* global Vuex:true */
import getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
  user: null, // 当前用户信息及用户token
  requestParameter: null,
  filterList: [], // 下来列表
  currentFilterValue: localStorage.getItem('filterValue'), // 筛选框的值
  headValue: '', // 多选框头部
  normalListData: [], // 通用列表数据
  multipleData: {}, // 多选框数据
  multipleValue: '', // 多选框选择值
  searchInputValue: '', // 输入框值
  detailId: '', // 详情id
  hotListData: {}, // 热点信息列表
  isSliderNav: true, // 首页轮播
  isTopNav: false, // 首页上方导航
  activeShow: '', // 多选框二级头部
  visible: false, // loading
  isHot: false, // 热点
  normalListDataPage: {
    currPage: 1,
    pageSize: 10
    // totalPage: 1001
  }
}

let store = new Vuex.Store({
  state,
  mutations,
  actions,
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js